import TransferAPI from '@/api/transferAPI';
import AuthAPI from './authAPI';
import UserAPI from './userAPI';
import SearchAPI from './searchAPI';
import BookingAPI from './bookingAPI';
import PaymentAPI from './paymentAPI';
import ClaimAPI from './claimAPI';
import ReviewAPI from './reviewAPI';
import i18n from '../lang';
import store from '../stores/store';
import ShippingAPI from './shippingAPI';
import ActivitiesAPI from './activitiesAPI';

const resources = {
  auth: AuthAPI,
  user: UserAPI,
  search: SearchAPI,
  booking: BookingAPI,
  payment: PaymentAPI,
  claim: ClaimAPI,
  review: ReviewAPI,
  shipping: ShippingAPI,
  activities: ActivitiesAPI,
  transfer: TransferAPI,
};

export const API = {
  get: (name) => resources[name],
};

export function errorResponse(error) {
  let response;
  if (!error.response) {
    response = { internal_error: [i18n.t('lang.alerts.internal_error')] };
  } else {
    if (error.response.status >= 400 && error.response.status < 500) {
      if (error.response.status === 400) {
        response = { internal_error: [i18n.t('lang.alerts.internal_error')] };
      } else if (error.response.status === 401) {
        response = { internal_error: [i18n.t('lang.alerts.auth_error')] };

        store.dispatch('removeUserData');
      } else {
        response = error.response.data.errors;
      }
    }
    if (error.response.status >= 500 && error.response.status < 600) {
      response = { internal_error: [i18n.t('lang.alerts.internal_error')] };
    }
  }

  if (!response) {
    response = { internal_error: [i18n.t('lang.alerts.internal_error')] };
  }

  return response;
}
